import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'form',
    path: 'action',
  })
  return function onClick() {
    change({ id: null, document_template: null })
  }
}
